<template>
  <div>
    <button
      @click.prevent="generateReport"
      class="button is-pulled-right w-full lg:w-auto mb-6 lg:mb-0"
      :class="{ 'is-loading': isLoading }"
    >
      <span class="icon"><i class="fas fa-sync-alt"></i></span>
      <span>Refresh report</span>
    </button>

    <div v-if="!meetingData">
      {{ status }}
    </div>
    <div v-else>
      <div class="select w-full lg:w-auto">
        <select v-model="selectedDate" class="w-full">
          <option value="0">Display all dates</option>
          <option
            v-for="(meetingDate, meetingDateIdx) in Object.keys(
              meetingData
            ).sort()"
            :key="meetingDateIdx"
            :value="meetingDate"
            >{{ formatDate(meetingDate) }}</option
          >
        </select>
      </div>
      <section
        class="my-8"
        v-if="selectedDate == 0 || selectedDate == meetingDate"
        v-for="(meetingDate, meetingDateIdx) in Object.keys(meetingData).sort()"
        :key="meetingDateIdx"
      >
        <h3 class="subtitle is-5 is-bold">
          <div class="media" style="align-items: center">
            <div class="media-content meeting-date">
              <span>{{ formatDate(meetingDate) }}</span>
            </div>
          </div>
        </h3>
        <div class="box">
          <table class="table is-hoverable is-fullwidth table-with-data-labels">
            <thead>
              <tr>
                <th scope="col">Time Slot</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(timeslot, tsIndex) in meetingData[meetingDate]"
                :key="tsIndex"
                :style="{}"
                :class="{
                  blocked: !timeslot.is_open && timeslot.scheduled_with === ''
                }"
              >
                <td data-label="Time" style="width:30%">
                  {{ `${timeslot.start_time} - ${timeslot.end_time}` }}
                </td>
                <td data-label="">
                  <ul class="divide-y divide-dividers">
                    <li
                      v-for="(appt, apptIdx) in timeslot.meetings"
                      :key="apptIdx"
                      class="py-2 first:pt-0"
                    >
                      <!-- <router-link :to="{name: 'AdminViewSchedule', params: {id: id, suiteId: appt[0].id}}" exact> -->
                      {{ appt[0].name }}
                      <!-- </router-link> -->
                      -
                      <!-- <router-link :to="{name: 'AdminViewSchedule', params: {id: id, suiteId: appt[1].id}}" exact> -->
                      {{ appt[1].name }}
                      <!-- </router-link> -->
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getScheduleReport } from '@/services/firebase';
import { formatDate } from '@/services/utils';
export default {
  props: {
    id: { type: String }
  },
  data() {
    return {
      status: 'Generating report...',
      isLoading: true,
      meetingData: undefined,
      selectedDate: 0
    };
  },
  methods: {
    formatDate,
    generateReport() {
      this.status = 'Generating report...';
      this.isLoading = true;
      this.meetingData = undefined;
      getScheduleReport({
        meetingId: this.id
      })
        .then(result => {
          this.meetingData = result.data;

          if (!this.meetingData) {
            this.status = 'No data found.';
          }

          this.isLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.status = 'Error loading report';
          this.isLoading = false;
        });
    }
  },
  mounted() {
    this.generateReport();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/meeting/ViewFullSchedule.vue